import React from "react";
import cx from "clsx";
import PropTypes from "prop-types";
import styles from "./select.module.scss";
import { Select, Form, Row } from "antd";
import styled from "styled-components";
import ViewField from "../ViewField";
import helper from '../../../helper/helper'

const { Option } = Select;

/*
 * Selection from ant
 * Props:
 * dataSource: [{key: "", value: ""}]*/

export default function SelectOptions({
    width,
    widthLabel,
    dataSource,
    classSelect,
    classOption,
    label,
    labelFontWeight,
    mandatory = true,
    name,
    name_value,
    mode = "editable",
    defaultValue,
    modeSelect,
    ...rest
}) {
    const noteLabel = label => {
        return (
            <Label fontWeight={labelFontWeight}>
                <span style={{ color: "red" }}>* </span>
                {label + ": "}
            </Label>
        );
    };

    return (
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "5px" }}>
            <div className={styles.FormStyles} style={{ fontWeight: "600", fontSize: "13px", color: "#000000d9", width: widthLabel }}>{mandatory ? (
                noteLabel(label)
            ) : labelFontWeight ? (
                <Label fontWeight={labelFontWeight}>{label}</Label>
            ) : label + ": "}
            </div>
            <Select
                showSearch
                style={{ width: width || 300 }}
                mode={modeSelect ? modeSelect : ""}
                className={cx(styles.select, classSelect)}
                optionFilterProp="children"
                defaultValue={defaultValue !== 0 ? defaultValue : undefined}
                {...rest}
            >
                {dataSource.map(item => (
                    <Option
                        key={item.id}
                        value={item[name_value]}
                        className={cx(styles.selectOption, classOption, 'select-option')}
                    >
                        {item[name]}
                    </Option>
                ))}
            </Select>
        </div>
    );
}

const Label = styled.span`
  font-weight: ${props => props.fontWeight};
`;

SelectOptions.propTypes = {
    width: PropTypes.string,
    widthLabel: PropTypes.string,
    name: PropTypes.string.isRequired,
    name_value: PropTypes.string.isRequired
};
